import React from 'react';
import { Box, Typography } from '@mui/material';
import { PipelineStages } from '../../types/crm';

const PipelineChart = ({ deals = [] }) => {
  const stageColors = {
    [PipelineStages.PROSPECT]: '#64748b',
    [PipelineStages.QUALIFIED]: '#0d9488', 
    [PipelineStages.TRIAL]: '#f59e0b',
    [PipelineStages.CLOSED_WON]: '#10b981',
    [PipelineStages.CLOSED_LOST]: '#ef4444'
  };

  const stageCounts = Object.values(PipelineStages).reduce((acc, stage) => {
    acc[stage] = deals.filter(deal => deal.stage === stage).length;
    return acc;
  }, {});

  const total = Object.values(stageCounts).reduce((sum, count) => sum + count, 0);
  const maxCount = Math.max(...Object.values(stageCounts));

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#0f172a', mb: 3 }}>
        Pipeline by Stage
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {Object.entries(stageCounts).map(([stage, count]) => {
          const percentage = total > 0 ? (count / total) * 100 : 0;
          const barWidth = maxCount > 0 ? (count / maxCount) * 100 : 0;
          
          return (
            <Box key={stage} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography 
                variant="body2" 
                sx={{ 
                  minWidth: '100px', 
                  fontSize: '0.8rem',
                  fontWeight: 500,
                  color: '#374151'
                }}
              >
                {stage}
              </Typography>
              <Box sx={{ flex: 1, position: 'relative', height: 20 }}>
                <Box
                  sx={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: '100%',
                    backgroundColor: '#f1f5f9',
                    borderRadius: 1
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100%',
                    width: `${barWidth}%`,
                    backgroundColor: stageColors[stage],
                    borderRadius: 1,
                    transition: 'width 0.3s ease'
                  }}
                />
              </Box>
              <Box sx={{ minWidth: '60px', textAlign: 'right' }}>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    fontWeight: 600, 
                    color: '#0f172a',
                    fontSize: '0.8rem'
                  }}
                >
                  {count}
                </Typography>
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: '#64748b',
                    fontSize: '0.7rem'
                  }}
                >
                  ({percentage.toFixed(0)}%)
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default PipelineChart;
